import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {CoreModule} from "./core/core.module";
import {MainModule} from "./main/main.module";
import {SharedModule} from "./shared/shared.module";
import {UiModule} from "@fedelta-pos/ui";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
      AppRoutingModule,
      BrowserModule,
      CoreModule,
      UiModule,
      MainModule,
      SharedModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
